import PropTypes from 'prop-types';
import NavLink from '../shared/buttons/nav-link';
import { DEFAULT_DECKS_ROUTE } from '../utils/index';

function PaymentVerify(props) {
  const { payment, code } = props;
  return (
    <div className='text-center text-xl'>
      {payment.status && ['100', '101'].includes(code) ? (
        code === '100' ? (
          <p>بسته‌های موردنظر شما با موفقیت خریداری گردید.</p>
        ) : (
          <p>تراکنش با موفقیت انجام شده است.</p>
        )
      ) : (
        <p>متاسفانه تراکنش ناموفق بود.</p>
      )}
      <p className='my-1'>
        <span>شماره تراکنش خرید: </span>
        <span>{payment.result.refId}</span>
      </p>
      <NavLink to={DEFAULT_DECKS_ROUTE} color='green' content='بازگشت' className='mx-auto my-6' />
    </div>
  );
}

PaymentVerify.propTypes = {
  payment: PropTypes.object.isRequired,
  code: PropTypes.string.isRequired
};

export default PaymentVerify;
